import { jsx } from "react/jsx-runtime";
import { Box } from "./Box.js";
function Tabs({
  children
}) {
  return /* @__PURE__ */ jsx(Box, {
    paddingTop: "6",
    paddingRight: "6",
    paddingBottom: "3",
    paddingLeft: "6",
    children
  });
}
export {
  Tabs
};
//# sourceMappingURL=Tabs2.js.map
